import PropTypes from 'prop-types';
import React from 'react';
import BaseComponent from 'apps/new-web/views/component';
import MuiMenuItem from '@material-ui/core/MenuItem';
import MuiListItemText from '@material-ui/core/ListItemText';
import MuiSelect from '@material-ui/core/Select';
import config from 'config';
import { withStyles } from '@material-ui/core/styles';
import { blueGray } from 'apps/new-web/views/themes/colors';
import I18n from 'apps/new-web/views/components/i18n';

const fallbackLanguages = [{ locale: 'en', name: 'english' }];

const styles = {
  selectMenu: {
    display: 'inline-flex',
    paddingRight: '0'
  },
  arrow: {
    display: 'none'
  },
  text: {
    padding: '0',
    fontSize: '.8125rem',
    color: blueGray
  }
};

export class LanguagePicker extends BaseComponent {

  static get propTypes() {
    return {
      lang: PropTypes.string.isRequired,
      languages: PropTypes.array.isRequired,
      onChange: PropTypes.func.isRequired,
      isTestable: PropTypes.bool,
      classes: PropTypes.shape({
        selectMenu: PropTypes.string,
        arrow: PropTypes.string,
        text: PropTypes.string
      })
    };
  }

  onChange(event) {
    this.props.onChange(event.target.value);
  }

  isProduction() {
    return config.env === 'production' || (typeof window !== 'undefined' && window.location.hostname === 'www.ifit.com');
  }

  render() {
    let languages = this.props.languages || fallbackLanguages;
    if (!this.isProduction()) {
      languages = [{ locale: 'ifit', name: 'ifit' }].concat(languages);
    }

    const languageMenuItems = languages.map((language) => {
      return (
        <MuiMenuItem
          value={ language.locale }
          className="language-picker-list-items"
          key={ language.locale }
        >
          <MuiListItemText
            classes={{ primary: this.props.classes.text }}
            primary={ language.name }
            className="lang-list-abbr"
          />
        </MuiMenuItem>
      );
    });

    return (
      <div className="language-picker-component">
        <span className="sr-only"><I18n desc="Invites user to select a language.">Select your preferred language. </I18n></span>
        <MuiSelect
          disableUnderline={ true }
          name="language-picker"
          value={ this.state.value || this.props.lang }
          aria-label={ I18n.translate('Language picker') }
          onChange={ this.onChange }
          classes={{
            selectMenu: this.props.classes.selectMenu,
            icon: this.props.classes.arrow
          }}
        >
          { languageMenuItems }
        </MuiSelect>
      </div>
    );
  }
}

export default withStyles(styles) (LanguagePicker);
